<template>
  <div class="ips avatar" :class="circleClass" :style="circleStyles">
    <span v-if="!hasImage" class="initials" :style="initialsStyles">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'IpsAvatar',
  props: {
    size: {
      name: 'size',
      description: 'The size of the avatar',
      type: String,
      default: 'md',
      required: false,
      validator: (value) => ['', 'sm', 'md', 'lg'].indexOf(value) !== -1,
    },
    imageSrc: {
      name: 'imageSrc',
      description: 'The source of the avatar image',
      type: String,
      default: null,
      required: false,
    },
  },
  computed: {
    circleClass() {
      switch (this.size) {
        case 'sm':
          return 'sm';
        case 'lg':
          return 'lg';
        case 'md':
        default:
          return 'md';
      }
    },
    circleSize() {
      switch (this.size) {
        case 'sm':
          return 28;
        case 'lg':
          return 48;
        case 'md':
        default:
          return 36;
      }
    },
    initialsStyles() {
      return `line-height: ${this.circleSize + 1}px;`;
    },
    circleStyles() {
      return this.hasImage
        ? `background-image: url("${this.imageSrc}"); background-size: ${this.circleSize}px`
        : '';
    },
    hasImage() {
      return Boolean(this.imageSrc);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'IpsAvatar';
</style>
